import Link from "@/components/shared/link";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type Props = {
  searchParams: { year: string; category: string };
  onClick?: () => void;
  tabs: string[];
  placeholder: string;
};
export function Categories({
  searchParams,
  tabs,
  placeholder,
  onClick,
}: Props) {
  return (
    <div className="flex gap-2 overflow-x-auto">
      {tabs.map((tab) => (
        <Link
          onClick={onClick}
          href={{
            pathname: "/honorees",
            query: { ...(searchParams ?? {}), year: tab },
          }}
          key={tab}
          className={buttonVariants({
            className: cn(
              "!h-10 !rounded-[1000px] bg-secondary/10 px-4 text-sm text-secondary transition-all duration-150 ease-in sm:!h-11 sm:px-5 sm:text-lg",
              tab === (searchParams?.year || placeholder)
                ? "bg-secondary text-background"
                : "hover:bg-secondary/20",
            ),
            variant: "ghost",
          })}
        >
          {tab}
        </Link>
      ))}
    </div>
  );
}
